import {Component, Input, OnInit} from '@angular/core';
import {HttpErrorResponse, HttpResponse} from '@angular/common/http';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import * as moment from 'jalali-moment';
import {StockService} from './stock.service';
import {IStock} from '../../shared/model/stock.model';
import {IStockMovement} from '../../shared/model/stock-movement.model';

@Component({
  selector: 'app-stock-history',
  templateUrl: './stock-history.component.html',
  styleUrls: ['./stock-history.component.scss']
})
export class StockHistoryComponent implements OnInit {
  @Input() stock: IStock;
  @Input() stockId: number;

  movements: IStockMovement[] = [];
  page = 1;
  itemsPerPage = 20;
  totalItems = 0;
  filter: 'ALL' | 'IN' | 'OUT' = 'ALL';
  loading = false;

  constructor(
    public activeModal: NgbActiveModal,
    private stockService: StockService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    if (!this.stock && this.stockId) {
      this.stockService.find(this.stockId).subscribe(
        (res: HttpResponse<IStock>) => {
          this.stock = res.body;
          this.load();
        },
        () => this.load()
      );
    } else {
      this.load();
    }
  }

  load(): void {
    const id = this.stockId || (this.stock && this.stock.id);
    if (!id) {
      return;
    }
    this.loading = true;
    this.spinner.show();
    this.stockService.findMovements(id, {
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: ['createdDate,desc']
    }).subscribe(
      (res: HttpResponse<IStockMovement[]>) => {
        this.movements = res.body || [];
        const total = res.headers.get('X-Total-Count');
        this.totalItems = total ? parseInt(total, 10) : this.movements.length;
        this.loading = false;
        this.spinner.hide();
      },
      (err: HttpErrorResponse) => {
        this.loading = false;
        this.spinner.hide();
        console.error(err);
      }
    );
  }

  get filteredMovements(): IStockMovement[] {
    if (this.filter === 'ALL') {
      return this.movements;
    }
    return this.movements.filter(m => m.direction === this.filter);
  }

  setFilter(f: 'ALL' | 'IN' | 'OUT'): void {
    this.filter = f;
  }

  loadPage(page: number): void {
    this.page = page;
    this.load();
  }

  clear(): void {
    this.activeModal.dismiss('cancel');
  }

  parseDateJalali(date: any): string {
    if (!date) {
      return '—';
    }
    try {
      return moment(date).locale('fa').format('YYYY/MM/DD HH:mm');
    } catch (e) {
      return '' + date;
    }
  }

  directionLabel(dir: string): string {
    return dir === 'IN' ? 'ورود' : dir === 'OUT' ? 'خروج' : dir || '—';
  }

  referenceLabel(m: IStockMovement): string {
    switch (m.referenceType) {
      case 'ORDER':
        return 'فروش' + (m.referenceCode ? ' · ' + m.referenceCode : '');
      case 'ORDER_BUY':
        return 'خرید' + (m.referenceCode ? ' · ' + m.referenceCode : '');
      case 'ORDER_RETURN':
        return 'مرجوعی سفارش';
      case 'MANUAL':
        return 'تعدیل دستی';
      case 'INITIAL':
        return 'موجودی اولیه';
      default:
        return m.referenceType || '—';
    }
  }

  partyLabel(m: IStockMovement): string {
    if (m.partyType === 'SUPPLIER') {
      return 'تامین‌کننده';
    }
    if (m.partyType === 'CUSTOMER') {
      return 'مشتری';
    }
    return m.direction === 'IN' ? 'تامین‌کننده' : 'مشتری';
  }
}
